import { render, staticRenderFns } from "./WisdomParamCycle.vue?vue&type=template&id=8f4a31f6&"
import script from "./WisdomParamCycle.vue?vue&type=script&lang=js&"
export * from "./WisdomParamCycle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports